import BannerList from "./BannerList";
import BannerCreate from "./BannerCreate";
import BannerEdit from "./BannerEdit";
import BannerShow from "./BannerShow";
import BannerIcon from "@mui/icons-material/ViewCarousel";

const banners = {
  list: BannerList,
  create: BannerCreate,
  edit: BannerEdit,
  show: BannerShow,
  icon: BannerIcon,
};

export default banners;
